import * as React from 'react';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { PickupStatsCategories } from '../../../../helpers';

interface MatchOverallPickupsCategoriesTabsProps {
    activeCategoryTab: PickupStatsCategories,
    setActiveCategoryTab: React.Dispatch<React.SetStateAction<PickupStatsCategories>>;
    categories: PickupStatsCategories[];
};

const MatchOverallPickupsCategoriesTabs = (props: MatchOverallPickupsCategoriesTabsProps) => {

    const toggle = (tab: PickupStatsCategories) => {
        if (props.activeCategoryTab !== tab)
        {
            props.setActiveCategoryTab(tab);
        }
    };

    return (
        <React.Fragment>
            {props.categories.length > 0 && (
                <Row className='mb-3'>
                    <Col>
                        <Nav tabs>
                            {props.categories.map((s, idx) => (
                                <NavItem key={idx}>
                                    <NavLink
                                        className={classnames({ active: props.activeCategoryTab === s })}
                                        onClick={() => { toggle(s); }}
                                    >
                                        {s}
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                    </Col>
                </Row>
            )}
        </React.Fragment>);
};

export default MatchOverallPickupsCategoriesTabs;